module.exports = __webpack_public_path__ + "static/media/vintage-car-wrecked-grayscale-photo.3f5c145d.jpg";